"use strict"; // From: https://github.com/FedericoDiRosa/react-window-scroller/blob/master/src/index.jsx

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactWindowScroller = void 0;

var lodash_1 = require("lodash");

var react_1 = __importStar(require("react"));

var ScrollableContainerContext_1 = require("../../dom/ScrollableContainerContext");

var isHtmlElement_1 = require("../../dom/isHtmlElement");

var windowScrollPositionKey = {
  y: 'pageYOffset',
  x: 'pageXOffset'
};
var documentScrollPositionKey = {
  y: 'scrollTop',
  x: 'scrollLeft'
};

function getFirstNonNil(items) {
  var _iterator = _createForOfIteratorHelper(items),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (item !== undefined && item !== null) return item;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return 0;
}

var getScrollPosition = function getScrollPosition(axis, element) {
  return getFirstNonNil([// @ts-ignore indexing as string
  element === null || element === void 0 ? void 0 : element[documentScrollPositionKey[axis]], // @ts-ignore indexing as string
  window[windowScrollPositionKey[axis]], // @ts-ignore indexing as string
  document.documentElement[documentScrollPositionKey[axis]], // @ts-ignore indexing as string
  document.body[documentScrollPositionKey[axis]]]);
};

function ReactWindowScroller(_ref) {
  var children = _ref.children,
      _ref$throttleTime = _ref.throttleTime,
      throttleTime = _ref$throttleTime === void 0 ? 10 : _ref$throttleTime,
      _ref$isGrid = _ref.isGrid,
      isGrid = _ref$isGrid === void 0 ? false : _ref$isGrid;
  var ref = (0, react_1.useRef)();
  var outerRef = (0, react_1.useRef)();

  var _ref2 = (0, ScrollableContainerContext_1.useScrollableContainerContext)(false) || {},
      target = _ref2.target;

  var targetElement = (target === null || target === void 0 ? void 0 : target.current) || window;
  (0, react_1.useEffect)(function () {
    var handleWindowScroll = (0, lodash_1.throttle)(function () {
      var _a, _b;

      var rect = (_b = (_a = outerRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
      var offsetTop = ((rect === null || rect === void 0 ? void 0 : rect.top) || 0) + ((0, isHtmlElement_1.isHtmlElement)(targetElement) ? targetElement.scrollTop : targetElement.scrollY);
      var offsetLeft = ((rect === null || rect === void 0 ? void 0 : rect.left) || 0) + ((0, isHtmlElement_1.isHtmlElement)(targetElement) ? targetElement.scrollLeft : targetElement.scrollX);
      var scrollTop = getScrollPosition('y', target === null || target === void 0 ? void 0 : target.current) - offsetTop;
      var scrollLeft = getScrollPosition('x', target === null || target === void 0 ? void 0 : target.current) - offsetLeft;
      if (isGrid) ref.current && ref.current.scrollTo({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });
      if (!isGrid) ref.current && ref.current.scrollTo(scrollTop);
    }, throttleTime);
    targetElement.addEventListener('scroll', handleWindowScroll);
    return function () {
      handleWindowScroll.cancel();
      targetElement.removeEventListener('scroll', handleWindowScroll);
    };
  }, [isGrid, targetElement]);
  var onScroll = (0, react_1.useCallback)(function (_ref3) {
    var scrollLeft = _ref3.scrollLeft,
        scrollTop = _ref3.scrollTop,
        scrollOffset = _ref3.scrollOffset,
        scrollUpdateWasRequested = _ref3.scrollUpdateWasRequested;

    var _a, _b;

    if (!scrollUpdateWasRequested) return;
    var top = getScrollPosition('y', target === null || target === void 0 ? void 0 : target.current);
    var left = getScrollPosition('x', target === null || target === void 0 ? void 0 : target.current);
    var rect = (_b = (_a = outerRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
    var offsetTop = ((rect === null || rect === void 0 ? void 0 : rect.top) || 0) + ((0, isHtmlElement_1.isHtmlElement)(targetElement) ? targetElement.scrollTop : targetElement.scrollY);
    var offsetLeft = ((rect === null || rect === void 0 ? void 0 : rect.left) || 0) + ((0, isHtmlElement_1.isHtmlElement)(targetElement) ? targetElement.scrollLeft : targetElement.scrollX);
    scrollOffset += Math.min(top, offsetTop);
    scrollTop += Math.min(top, offsetTop);
    scrollLeft += Math.min(left, offsetLeft);
    if (!isGrid && scrollOffset !== top) targetElement.scrollTo(0, scrollOffset);

    if (isGrid && (scrollTop !== top || scrollLeft !== left)) {
      targetElement.scrollTo(scrollLeft, scrollTop);
    }
  }, [isGrid, targetElement]);
  react_1.default.useEffect(function () {
    // We have to get rid of the scroll handlers here, because they will cause the list
    // to go blank whenever adjusting the number of items.
    ref.current._onScrollVertical = function () {};

    ref.current._onScrollHorizontal = function () {};
  }, [outerRef]);
  return children({
    ref: ref,
    outerRef: outerRef,
    style: {
      width: isGrid ? 'auto' : '100%',
      height: '100%',
      display: 'inline-block',
      overflow: 'hidden',
      zIndex: 3
    },
    onScroll: onScroll
  });
}

exports.ReactWindowScroller = ReactWindowScroller;